import http from '@/utils/http/index'

// 订单信息
export function getOrderInfo(id) {
  return http.get(`/subscription/plan/detail?planUuid=${id}`)
}

// 取消订阅发验证码
export function unsubscribeSendEmail(id) {
  return http.post(`/subscription/plan/cancel/sendEmail?planUuid=${id}`)
}

// 取消订阅
export function unsubscribe(data) {
  return http.post('/subscription/plan/cancel', data)
}
